import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/home.vue'
// import api from '@/api/index.js';

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    meta: {
      title: '首页',
      islogin: false
    },
    component: HomeView
  },
  {
    path: '/pretest',
    name: 'pretest',
    meta: {
      title: '预检',
      islogin: true
    },
    // route level code-splitting
    // this generates a separate chunk (pretest.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "pretest" */ '../views/pretest.vue')
  },
  {
    path: '/scorequery-personal',
    name: 'scorequery-personal',
    meta: {
      title: '个人成绩查询',
      islogin: false
    },
    component: () => import('../views/scorequery/personal.vue')
  },
  {
    path: '/scorequery-mailing',
    name: 'scorequery-mailing',
    meta: {
      title: '证书邮寄管理',
      islogin: false
    },
    component: () => import('../views/scorequery/mailing.vue')
  },
  {
    path: '/cert-verify',
    name: 'cert-verify',
      meta: {
      title: '电子证书查验',
      islogin: false,
      hideTopbar: true,
    },
    component: () => import('../views/scorequery/cert-verify.vue'),
  },
  {
    path: '/cert-verify/:certNo',
    name: 'cert-verify-certNo',
      meta: {
      title: '电子证书查验',
      islogin: false,
      hideTopbar: true,
    },
    component: () => import('../views/scorequery/cert-verify.vue'),
  },
  {
    path: '/scorequery-group',
    name: 'scorequery-group',
    meta: {
      title: '团体成绩查询',
      islogin: true
    },
    component: () => import('../views/scorequery/group.vue')
  },
  {
    path: '/papersubmit-agreement',
    name: 'papersubmit-agreement',
    meta: {
      title: '论文提交须知',
      islogin: true
    },
    component: () => import('../views/papersubmit/agreement.vue')
  },
  {
    path: '/papersubmit-add',
    name: 'papersubmit-add',
    meta: {
      title: '论文提交',
      islogin: true
    },
    component: () => import('../views/papersubmit/add.vue')
  },
  {
    path: '/papersubmit-query',
    name: 'papersubmit-query',
    meta: {
      title: '论文提交记录',
      islogin: true
    },
    component: () => import('../views/papersubmit/query.vue')
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})
router.beforeEach((to, from, next) => {
  document.title = to.meta.title ? `${to.meta.title} - 建模能力` : '建模能力';
  console.log(to, '===>', from)
  let token = localStorage.getItem('token');
  if (to.meta.islogin && !token) {
    Vue.prototype.$alert('检测到您还未登录', '提示', {
      confirmButtonText: '确定',
      callback: () => {
        next({ name: 'home' })
      }
    })
    // api.getCurrentUser()
    //   .then((res) => {
    //     if (res.code !== 0) {
    //       Vue.prototype.$alert('检测到您还未登录', '提示', {
    //         confirmButtonText: '确定',
    //         callback: () => {
    //           next({ name: 'home' })
    //         }
    //       })
    //     } else {
    //       next()
    //     }
    //   })
    // api.islogin()
    //   .then((res) => {
    //     if (res.data === -1) {
    //       Vue.prototype.$alert('检测到您还未登录', '提示', {
    //         confirmButtonText: '确定',
    //         callback: () => {
    //           next({ name: 'home' })
    //         }
    //       })
    //     } else {
    //       next()
    //     }
    //   })
  }
  next()
})

export default router
